module.exports = __webpack_public_path__ + "static/media/Send@2x.df4d48c7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/img/Send@2x.png
// module id = 205
// module chunks = 0